export default __webpack_public_path__ + "static/media/Support_Customer-Story-Telecomms-Comp.f3357774.jpg";